
import gql from 'graphql-tag'

import * as actions from '../store/actions'
import * as store from '../store/store'
import router from '../router/index'

let storedClient
let handle

export function storeClient(client) {
  storedClient = client
  let team = store.default.getters.team
  if (team && team.idTeam) {
    setUpClient(team.idTeam)
  }
}

export function setUpClient(teamId) {

  const subquery = gql(`
subscription subscribeToNotification {
subscribeToNotification(teamId: "${teamId}") {
    teamId
    gameId
    content
}
}`)
  console.log('gonna try to subscribe')

  const notifObservable = storedClient.subscribe({ query: subquery })
  handle = notifObservable.subscribe({
    next: realtimeResults,
    complete: console.log,
    error: console.log,
  })
}

const realtimeResults = function realtimeResults(data) {
  console.log('REAL TIME DATA', data)
  const notificationObject = data.data.subscribeToNotification
  if (notificationObject.content === 'LOG_OUT') {
    actions.logoutTeam(store.default)
    router.push({ name: 'TeamLogin' })
    handle.unsubscribe()
  }
}



// WEBPACK FOOTER //
// ./src/services/app-sync-service.js